import Modal from "components/Modal";
import { useModalStore, Modal as ModalKey } from "stores/modal/useModalStore";
import AddHorse from "components/Forms/Horse/AddHorse";
import DeleteForm from "components/Forms/Horse/DeleteForm";
import { EditHorse } from "components/Forms/Horse/EditHorse";
import { useHorseStore } from "stores/horse/useHorseStore";

export const HorseFormModal = () => {
  const close = useModalStore((s) => s.close);
  const current = useModalStore((s) => s.current);

  const selectAll = useHorseStore(state => state.selectAll);
  const deleteHorses = useHorseStore(state => state.deleteHorses);
  const setDeleteHorses = useHorseStore(action => action.setDeleteHorses);

  const isAddHorse = current === ModalKey.AddHorse;
  const isEditHorse = current === ModalKey.EditHorse;
  const isDeleteHorse = current === ModalKey.DeleteHorse;

  const modalHeightClass = isDeleteHorse ? "h-[300px]" : "h-auto";

  return (
    <Modal
      isCloseIcon
      overlayZIndex={1000}
      contentZIndex={1001}
      modalIsOpen={isAddHorse || isEditHorse || isDeleteHorse}
      closeModal={() => {
        if (isDeleteHorse) {
          close();
          setDeleteHorses([]);
        } else {
          close();
        }
      }}
      className={`w-[360px] sm:!w-auto flex flex-col items-center justify-center p-10 ${modalHeightClass}`}
      title={
        isEditHorse
          ? "Edit Horse"
          : deleteHorses.length
            ? deleteHorses.length > 1 && selectAll
              ? "Delete All Horses"
              : "Delete horse"
            : "Add Horse"
      }
    >
      {{
        content: isEditHorse ? (
          <EditHorse />
        ) : isDeleteHorse ? (
          <DeleteForm />
        ) : (
          <AddHorse />
        ),
      }}
    </Modal>
  );
};

export default HorseFormModal;
